/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import "./index.css";
import { useState } from "react";
import {
  AGENT_DETAILS_URL,
  CONTACT_AGENT_URL,
  PROPERTIES_URL,
} from "../../Global/API's";
import PropertyItem from "../../Components/PropertyItem";
import { useParams } from "react-router-dom";
import LoadingView from "../../Components/Loader";
import Swal from "sweetalert2";
import { PulseLoader } from "react-spinners";

const Agentdetails = () => {
  const { id } = useParams();
  const [propertiesData, setPropertiesData] = useState([]);
  const [agentDetails, setAgentDetails] = useState([]);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const getPropertiesData = async () => {
    const URL = `${PROPERTIES_URL}?userAgentID=${id}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const responsive = await fetch(URL, options);

    if (responsive.ok) {
      const data = await responsive.json();
      setPropertiesData(data);
    }
  };

  const getAgentsDetails = async () => {
    try {
      const responsive = await fetch(`${AGENT_DETAILS_URL}?userID=${id}`);
      const fetchedData = await responsive.json();
      setAgentDetails(fetchedData);
    } catch (error) {
      console.log(error);
    }
  };

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  useEffect(() => {
    getAgentsDetails();
    getPropertiesData();
  }, [id]);

  const onContactAgent = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const { name, email, phone, message } = userDetails;
    try {
      const formValues = {
        agent_id: agentDetails?.data?.userID,
        type: 2,
        name,
        email,
        phone,
        message,
      };
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      const options = {
        method: "POST",
        body: formData,
      };
      const response = await fetch(CONTACT_AGENT_URL, options);
      const data = await response.json();
      console.log(data);
      if (data.status === "Success") {
        showSwal();
        setUserDetails({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderFormView = () => {
    const { name, email, phone, message } = userDetails;
    return (
      <div className="text-container">
        <h5>Contact</h5>
        <form id="contactAgent" onSubmit={onContactAgent}>
          <div className="row">
            <input
              value={agentDetails?.data?.userID}
              type="hidden"
              className="form-control"
              name="agent_id"
            />
            <input
              value={2}
              type="hidden"
              className="form-control"
              name="type"
            />
            <div className="col-sm-12 mb-3">
              <input
                required
                type="text"
                placeholder="Full Name"
                className="form-control"
                name="name"
                value={name}
                onChange={onHandleChange}
              />
            </div>
            <div className="col-sm-6 mb-3">
              <input
                required
                type="email"
                placeholder="Email Address"
                className="form-control"
                name="email"
                value={email}
                onChange={onHandleChange}
              />
            </div>
            <div className="col-sm-6 mb-3">
              <input
                required
                type="text"
                placeholder="Phone"
                className="form-control"
                name="phone"
                value={phone}
                onChange={onHandleChange}
              />
            </div>
            <div className="col-sm-12 mb-3">
              <textarea
                name="message"
                className="form-control"
                placeholder="Message"
                value={message}
                onChange={onHandleChange}
              ></textarea>
              <button className="btn" disabled={isLoading} type="submit">
                {isLoading ? (
                  <PulseLoader color="#fff" size={10} />
                ) : (
                  "Send Message"
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  };

  const renderConfirmMessageView = () => `<div class="confirm-message-body">
      <img src="/assets/images/request-icon.png" alt="" />
      <h4>Thank you for your inquiry.</h4>
      <p>An agent will be contact with you.</p>
    </div>`;

  const showSwal = () => {
    Swal.fire({
      html: renderConfirmMessageView(),
      showConfirmButton: true,
      confirmButtonText: "OK",
      confirmButtonColor: "#df1a33",
    });
  };

  const renderAgentData = () => {
    const {
      agentPhotoURL,
      agentFirstName,
      agentLastName,
      agentTitle,
      agentCellPhone,
      agentOfficePhone,
    } = agentDetails.data;

    return (
      <div className="row">
        <div className="col-lg-8 col-md-7">
          <div className="left-block">
            <h2>
              {agentFirstName} {agentLastName}
            </h2>
            <h5>{agentTitle}</h5>
            <div className="text-container">
              <h5>DRE# 01986308</h5>
              <p>
                As a full time professional real estate agent, I pride myself on
                offering superior personal service before, during and after your
                transaction. Knowledge, commitment, honesty, expertise and
                professionalism are the cornerstone of my business. Let me earn
                your trust, your business and most importantly your friendship.
                Don’t make another move without me. I guarantee you will see the
                difference quality service makes. I look forward to working with
                you!
              </p>
            </div>
            {propertiesData.status === "Success" && (
              <div className="agent-listsings text-container">
                <h5>Agent Listings</h5>
                <p>View the latest properties listed with Agent.</p>

                <ul className="property-listings">
                  {propertiesData.data.map((item, index) => (
                    <PropertyItem key={index} eachProperty={item} />
                  ))}
                </ul>
              </div>
            )}
            {/* {renderFormView()} */}
            {/* {swalShown &&
              createPortal(renderConfirmMessageView(), Swal.getHtmlContainer())} */}
          </div>
        </div>
        <div className="col-lg-4 col-md-5">
          <div className="profile-details agent">
            <figure>
              <img src={agentPhotoURL} alt="" />
            </figure>
            <div className="text-block">
              <h4>
                {agentFirstName} {agentLastName}
              </h4>
              <h5>{agentTitle}</h5>
              <p>
                Cell Phone :
                <a href={`tel:${agentCellPhone}`}> {agentCellPhone}</a>
              </p>
              <p>
                Office Phone :
                <a href={`tel:${agentOfficePhone}`}> {agentOfficePhone}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <main className="agent-details-page">
      <section className="agent-banner agent-details-banner">
        <div className="container-fluid">
          <div className="text-content">
            <h1>Agents</h1>
            <p>
              Like us? Love us? Just want to say hello? We’d like to hear from
              you!
            </p>
          </div>
        </div>
      </section>
      <section className="agent-details">
        <div className="container-fluid">
          {agentDetails.status === "Success" ? (
            renderAgentData()
          ) : (
            <LoadingView />
          )}
        </div>
      </section>
      {/* {propertiesData.status === "Success" && (
        <section className="agent-listsings">
          <div className="container-fluid">
            <h2>Agent Listings</h2>
            <p>View the latest properties listed with Agent.</p>

            <ul className="property-listings">
              {propertiesData.data.map((item, index) => (
                <PropertyItem key={index} eachProperty={item} />
              ))}
            </ul>
          </div>
        </section>
      )} */}
    </main>
  );
};

export default Agentdetails;
